import React, { useEffect, useState } from "react";
import { AlertDialog } from "@preownedfront/lib-reowds";
import { ROUTE_PATHS } from "../../utils/constants";
import { t } from "i18next";
import { useAppState } from "src/hooks/state/use-app-state";
import { useHistory } from "react-router-dom";
import useMyPersonalDataQuery from "src/hooks/React_Query/Customer/Buyer/PersonalData/useMyPersonalDataQuery";
import {
  showAlertDialog,
  getTitle,
  getDescription,
  getCancelButtonLabel,
} from "./AlertDialogDAC7.utils";
import { AlertProps, StateGlobal } from "./AlertDialogDAC7.model";
import { useNavigationHistory } from "src/utils/providers/NavigationHistoryProvider";

export function AlertDialogDAC7({ variant }: AlertProps) {
  const user = useAppState((state) => state.profile.user);
  const [globalStatus, setGlobalStatus] = useState<StateGlobal>({
    openAlert: false,
    financialStatus: "",
  });
  const history = useHistory();
  const { safeNavigateBack } =  useNavigationHistory();
  const {
    data: myPDResponse,
  } = useMyPersonalDataQuery(!!user?.logonId);

  useEffect(() => {
    if(!user?.logonId) return;
    const status = myPDResponse?.data?.financialRegulationStatus;
    setGlobalStatus({
      openAlert: showAlertDialog(variant, status),
      financialStatus: status,
    });
  }, [user, myPDResponse]);

  const onClickAcceptButton = () => {
    setGlobalStatus({ openAlert: false, financialStatus: "" });
    history.push(ROUTE_PATHS.STATEMENT_DAC7);
  };

  const onClickCancelButton = () => {
    setGlobalStatus({ openAlert: false, financialStatus: "" });
    if (variant === "SELL") {
     safeNavigateBack();
    };
  };

  return (
    <AlertDialog
      title={getTitle()[variant]?.[globalStatus.financialStatus] || ""}
      acceptButtonLabel={t("statement-dac7-button")}
      description={getDescription()[variant]?.[globalStatus.financialStatus] || ""}
      open={globalStatus.openAlert}
      cancelButtonLabel={getCancelButtonLabel()[variant] || ""}
      onClickAcceptButton={() => onClickAcceptButton()}
      onClickCancelButton={() => onClickCancelButton()}
    />
  );
}

export default AlertDialogDAC7;
